import React from 'react'
import { Grid, Container } from '@material-ui/core';
import Form from '../form-builder/form';
import PropTypes from 'prop-types';

const SimpleForm = (props) => {
    if (props.hidden) {
        return (null);
    } else {
        return (
            <Container>
                <Grid item xs={12}>
                    <Form
                        schema={props.schema}
                        values={props.values||{}}
                        onSubmit={props.onSubmit}
                        onCancel={props.onCancel}
                        children={props.children||[]}
                        disableSaveButton={props.disableSaveButton||false}
                        buttons={{
                            align: 'flex-end',
                        }}
                        />
                </Grid>
            </Container>            
        );
    }
}


SimpleForm.propTypes = {
    schema: PropTypes.object.isRequired,
    values: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    disableSaveButton: PropTypes.bool,
} 

export default SimpleForm;